export const indiciesTitle = [
  { name: 'دوام', slug: 'durability', value: 20 },
  { name: 'ارزش خرید', slug: 'worth', value: 20 },
  { name: 'کیفیت', slug: 'quality', value: 20 },
  { name: ' عملکرد و کارایی', slug: 'performance', value: 20 },
];
